import React, { useState, useEffect, useRef } from 'react';
import popup from 'assets/images/popup.png';

const Popup = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [fadeIn, setFadeIn] = useState(false);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleScroll = (event) => {
      if (isVisible) {
        event.preventDefault();
        event.stopPropagation();
      }
    };

    const handleClickOutside = (event) => {
      if (isVisible && popupRef.current && !popupRef.current.contains(event.target)) {
        handlePopupClose();
      }
    };

    if (isVisible) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('scroll', handleScroll, { passive: false });
      document.addEventListener('mousedown', handleClickOutside);

      // Ativa o fade-in após um pequeno atraso
      const timer = setTimeout(() => setFadeIn(true), 10);

      return () => clearTimeout(timer);
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'auto';
    };
  }, [isVisible]);

  const handlePopupClose = () => {
    setFadeIn(false); // anima o fade-out
    setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, 300); // espera o fade-out antes de fechar
  };

  return (
    <main
      className={`z-50 fixed inset-0 flex items-center justify-center bg-black bg-opacity-65 backdrop-blur-md transition-opacity duration-500 ${fadeIn ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
      onClick={handlePopupClose}
    >
      <article
        className="relative flex flex-col justify-center items-center p-8 rounded-lg"
        onClick={(e) => e.stopPropagation()}
        ref={popupRef}
      >
        <a href="https://www.e-inscricao.com/Ictuscarbon/ivaipora" target="_blank">
          <img
            src={popup}
            alt="Popup"
            loading='lazy'
            className="md:max-w-[540px] rounded-xl  cursor-pointer"
          />
        </a>
      </article>
    </main>
  );
};

export default Popup;